import type { Toast } from "@components/Toast.js";

export const toasts = $state<{
	items: Toast[];
	toastDelay: number;
}>({
	items: [],
	toastDelay: 3500,
});
